import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { motion, useAnimation } from 'framer-motion';

// import actions
import { toggleModalOverlay } from 'js/store/app/App.actions';

// import selecrtors
import { getModalState } from 'js/store/app/App.selectors';

// import components
import ButtonBackCross from 'js/components/button/Button.back-cross';
import CollectionModal from 'js/containers/stack/collection/Collection.model';
import CardShareModal from 'js/containers/stack/card/Card.share';

const modalVariants = {
  hidden: { y: '100vh' },
  visible: {
    y: 0,
    transition: { ease: 'easeInOut', duration: 0.75 },
  },
  exit: { y: '100vh', transition: { ease: 'easeInOut', duration: 0.5 } },
};

const Modal = () => {
  const dispatch = useDispatch();
  const modalState = useSelector(getModalState);

  const controls = useAnimation();
  useEffect(() => {
    if (modalState) {
      controls.start('visible').then(() => {
        document.body.style.overflow = 'hidden';
      });
    }
  }, [modalState]);

  const close = () => {
    controls.start('exit').then(() => {
      document.body.style.overflow = 'auto';
    });
  };

  const closeModal = () => {
    dispatch(toggleModalOverlay(false));
    close();
  };

  const renderChildren = () => {
    switch (modalState.type) {
      case 'COLLECTION':
        return <CollectionModal {...modalState} closeModal={closeModal} />;
      case 'CARD':
        return <CardShareModal {...modalState} closeModal={closeModal} />;
      default:
        return null;
    }
  };

  return (
    <motion.div className="modal--overlay" variants={modalVariants} initial="hidden" animate={controls}>
      <div className="modal--overlay__container">
        <ButtonBackCross action={closeModal} />
        {renderChildren()}
      </div>
    </motion.div>
  );
};

export default Modal;
